import { MenuItemStyled } from '@molecules/Filters/styles';
import { SelectChangeEvent } from '@mui/material';
import { EPriorityLinkManagement } from '@organisms/Tables/Enterprise/LinksManagementTable/enums';
import { getConfigPriorityLinkManagement } from '@organisms/Tables/Enterprise/LinksManagementTable/utils';
import CustomSelect from '../CustomSelect/CustomSelect';
import { ICustomSelectProps } from '../types';
import React from 'react';

interface ILinkManagementPrioritySelectProps extends ICustomSelectProps {}

const LinkManagementPrioritySelect = ({
  savedDataSelectedRow,
  setSavedDataSelectedRow,
  handleClose,
  customSxForSelect,
  ...props
}: ILinkManagementPrioritySelectProps) => {
  const handleOnChange = (event: SelectChangeEvent<unknown>) => {
    event.stopPropagation();
    setSavedDataSelectedRow({
      ...savedDataSelectedRow,
      priority: event.target.value as EPriorityLinkManagement,
    });
  };

  return (
    <CustomSelect
      title="Priority:"
      listData={EPriorityLinkManagement}
      handleOnChange={handleOnChange}
      handleClose={handleClose}
      customSxForSelect={customSxForSelect}
      {...props}
    >
      {Object.entries(EPriorityLinkManagement).map(([, priority]) => {
        const config = getConfigPriorityLinkManagement(priority as EPriorityLinkManagement);
        return (
          <MenuItemStyled key={priority} value={priority} sx={{ color: config?.color }}>
            {config?.priority}
          </MenuItemStyled>
        );
      })}
    </CustomSelect>
  );
};

export default React.memo(LinkManagementPrioritySelect);
